import React from 'react';
import fr from 'facet-rest';
import { pick } from 'Helpers/Affordances';
import { useDashboardContext } from 'Views/Dashboard/DashboardContext';
import NewClientPostScenarioOverviewCard
  from 'Views/Dashboard/NewClientPostScenarioOverviewCardPicker/NewClientPostScenarioOverviewCard';

const NewClientPostScenarioOverviewCardPicker = () => {
  const { clientDashboardResource } = useDashboardContext();

  const Component = pick(clientDashboardResource, {
    [fr.relationships.waitlistScheduleChiliPiperMeeting.name]: NewClientPostScenarioOverviewCard,
    [fr.relationships.scheduleMeetingWithPlanner.name]: NewClientPostScenarioOverviewCard,
    [fr.relationships.upcomingMeeting.name]: NewClientPostScenarioOverviewCard,
  }, null);

  if (!Component) {
    return null;
  }

  return <Component />;
};

export default NewClientPostScenarioOverviewCardPicker;
